import composeStore from '../store/composeStore';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { select } from 'satcheljs/lib/legacy';
export default select({
    pendingViewState: function () { return composeStore.pendingViewState; },
    hasFloatingViewState: function () { return composeStore.floatingViewStates.size > 0; },
    asyncSendEnabled: function () { return getUserConfiguration().AsyncSendEnabled; },
})(function shouldUseAsyncSend(viewState, state) {
    return (state.asyncSendEnabled &&
        !state.pendingViewState &&
        !state.hasFloatingViewState &&
        viewState.preferAsyncSend);
});
//# sourceMappingURL=shouldUseAsyncSend.js.map